<template>
	<div id="forgot-password" class="authenticate">
		<app-head title="Forgot Password" />

		<v-card elevation="0">
			<v-card-title>
				<div class="d-flex w-100">
					<h5 class="text-h5 mb-3 font-weight-bold">
						Password Reset
					</h5>
					<div class="ml-auto">
						<v-icon>mdi-lock-question</v-icon>
					</div>
				</div>
			</v-card-title>
			<v-card-text>
				<v-alert
					v-if="message"
					class="mt-4 mb-5"
					text
					type="success">
					Please <strong>check your email</strong> for the link!
				</v-alert>
				<v-form v-model="valid" @submit.prevent="handleForm">
					<v-text-field
						v-model="form.email"
						type="email"
						name="email"
						:error="exists(form.errors.email)"
						:error-messages="form.errors.email"
						:class="{'mb-3': form.errors.email}"
						label="Email Address"
						required
						persistent-placeholder
						outlined
						autofocus></v-text-field>
					<v-divider class="my-4" />
					<div class="d-flex align-center">
						<v-btn
							elevation="0"
							large
							rounded
							color="primary"
							type="submit"
							:loading="form.processing">
							Request Password
						</v-btn>
						<div class="ml-4">or</div>
						<div class="ml-5">
							<Link :href="route('login')" class="v-size--default theme--light text-decoration-none text--secondary text-uppercase">
								Back to Login
							</Link>
						</div>
					</div>
				</v-form>
			</v-card-text>
		</v-card>

		<v-snackbar
			v-model="snackbar"
			color="success"
			shaped
			top
			timeout="15000">
			{{ message }}
		</v-snackbar>
	</div>
</template>
<script>
import Auth from '@/Layouts/Auth'
import AppHead from '@/Shared/AppHead'
import form from '@/Mixins/form'

export default {
	components: { AppHead },
	mixins: [form],
	layout: Auth,
	props: {
		//
	},
	data () {
		return {
			valid: false,
			form: this.$inertia.form({
				email: null
			}),
			snackbar: false,
			message: '',
			timeout: 2000
		}
	},
	methods: {
		handleForm () {
			this.form.post(this.route('password.email'), {
				onSuccess: () => {
					this.form.reset()
					this.message = 'Password reset link has been emailed to you.'
					this.snackbar = true
				}
			})
		}
	}
}
</script>
